// @flow

import styled, { css } from "styled-components";
import Icon from "@fdr/static-ui/Icons";
import { fontCondensed } from "@fdr/static-ui/Typography";

import buildColor from "@fdr/static-ui/ColorPalette";

import ButtonDefault from "../ButtonDefault";
import Tag from "../Tag";

export const Selection = styled(ButtonDefault)`
  vertical-align: auto;
  ${({ selectionType }) =>
    selectionType === "default"
      ? css`
          font-weight: bold;
          width: 64px;
          border: 1px solid ${buildColor("blue", "500")};
          border-radius: 3px;
        `
      : css`
          width: 100%;
          flex: 1 1 auto;
          border-right: 1px solid ${buildColor("blue", "500")};

          &:first-of-type {
            border-radius: 3px 0 0 3px;
          }
        `};
  font-size: 14px;
  position: relative;
  height: 46px;

  &:hover :active {
    background-color: ${buildColor("grey", "100")};
  }

  &,
  &:focus,
  &:hover {
    ${({ isChecked }) =>
      isChecked
        ? css`
            color: ${buildColor("white", "100")};
            background-color: ${buildColor("blue", "500")};
          `
        : css`
            color: ${buildColor("blue", "500")};
            background-color: ${buildColor("white", "100")};
          `};
    ${({ isAllSelected }) =>
      isAllSelected &&
      css`
        background-color: ${buildColor("blue", "100")};
        color: ${buildColor("blue", "500")};
      `};
  }
`;

export const FavTag = styled(Tag)`
  position: absolute;
  top: -8px;
  right: -5px;
  width: 30px;
`;

export const TrendingIcon = styled(Icon)`
  position: absolute;
  top: 0;
  left: 0;
`;

export const LabelDescription = styled.span`
  font-family: ${fontCondensed};
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 1px;
  text-align: center;
  text-transform: uppercase;
`;

export const LabelContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 0 2px;
`;
